module.exports = __webpack_public_path__ + "static/media/checkmark.ba1dcb97.png";